import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../api/apiClient";
import "./LoginPage.css";
import { applySessionToken } from "../../utils/authSession";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // 2FA state
  const [requiresTwoFactor, setRequiresTwoFactor] = useState(false);
  const [preAuthToken, setPreAuthToken] = useState("");
  const [totpCode, setTotpCode] = useState("");

  const applyToken = (token) => {
    applySessionToken(token, navigate);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    try {
      const { data } = await apiClient.post("/auth/login", { username, password });

      if (data.requiresTwoFactor) {
        setPreAuthToken(data.preAuthToken);
        setRequiresTwoFactor(true);
        return;
      }

      const { token, mustChangePassword, resetPasswordToken } = data;
      if (mustChangePassword && resetPasswordToken) {
        navigate(`/users/password/${resetPasswordToken}`);
        return;
      }
      applyToken(token);
    } catch (error) {
      setErrorMsg(error.response?.data.message || "Error en la autenticación");
    }
  };

  const handleTotpSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    try {
      const { data } = await apiClient.post("/auth/2fa/login", { preAuthToken, code: totpCode });
      applyToken(data.token);
    } catch (error) {
      setErrorMsg(error.response?.data.message || "Código incorrecto");
    }
  };

  const handleBackToLogin = () => {
    setRequiresTwoFactor(false);
    setPreAuthToken("");
    setTotpCode("");
    setErrorMsg("");
  };

  if (requiresTwoFactor) {
    return (
      <div className="login-container">
        <div className="login-box">
          <img src="/logo512.png" alt="Logo DeliLife" className="login-logo" />
          <h2 className="login-title">Verificación en dos pasos</h2>
          <p className="login-subtitle">Ingresa el código de 6 dígitos de tu aplicación autenticadora</p>
          {errorMsg && <p role="alert" className="error">{errorMsg}</p>}
          <form onSubmit={handleTotpSubmit}>
            <input
              type="text"
              inputMode="numeric"
              placeholder="Código de 6 dígitos"
              value={totpCode}
              onChange={e => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              maxLength={6}
              autoComplete="one-time-code"
              required
            />
            <button type="submit">Verificar</button>
          </form>
          <button className="login-back-link" onClick={handleBackToLogin}>
            ← Volver al inicio de sesión
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <img src="/logo512.png" alt="Logo DeliLife" className="login-logo" />
        <h2 className="login-title">Iniciar Sesión</h2>
        {errorMsg && <p role="alert" className="error">{errorMsg}</p>}
        <form onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Correo o usuario"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Contraseña"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button type="submit">Entrar</button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
